<template>
  <div>
    <base-header class="pb-6 bg-gradient-info">
   
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-lg-6">
          <card header-classes="bg-transparent">
            <h3 slot="header" class="mb-0">Timeline</h3>

            <time-line type="one-side">

              <time-line-item 
              		v-for="task in tasks"  :key="task.id"
              				  badge-type="success"
                              badge-icon="ni ni-bell-55">

                <small v-if="task.header_type==7" class="text-muted font-weight-bold">Company Incorporated On {{task.incorp_date_str}}. </small>
                 <small v-if="task.header_type==12" class="text-muted font-weight-bold">Change Of Company Secretary. Company Structure As of {{task.filed_datetime_str}}</small>
                 <small v-else-if="task.task_name_sys=='agm'" class="text-muted font-weight-bold">Held On {{task.schedule_date_str}}</small>
                <small v-else class="text-muted font-weight-bold">Filed On {{task.filed_datetime_str}}</small>
                
                <div style="margin-top:25px; margin-bottom:5px"><h5 class=" mt-3 mb-0">
                	<span v-if="task.header_type==1">Directors' Resolution</span> 
                	<span v-if="task.header_type==2">Shareholders' Resolution (EGM)</span> 
                
                </h5></div>
              		<base-alert v-if="task.header_type==7"  type="warning" icon="ni ni-spaceship">
         						  <i class="ni ni-circle-08"></i>   
         						  &nbsp; {{task.entity_name}} has been incorporated!
          		   </base-alert>	
          		   
          		   <base-alert v-if="task.task_name_sys=='ar'"  type="warning" icon="ni ni-spaceship">
         						  <i class="fa fa-gavel"></i>   
         						  &nbsp; {{task.task_name}}
          		   </base-alert>	 
          		   
          		     <base-alert v-if="task.task_name_sys=='agm'"  type="warning" icon="ni ni-spaceship">
         						  <i class="fa fa-users"></i>   
         						  &nbsp; {{task.task_name}}
          		   </base-alert>	   
         						  
              	 	
                   <div v-for="cr in task.cr" :key="cr.key_id">
               			
               			
               			 <!--  start -->
               			<span v-if="cr.type=='change_officer'">
               			
               				 <base-alert  type="default" icon="ni ni-like-2">
         						  <i class="ni ni-circle-08"></i>   
         						  &nbsp;
         						     {{cr.data.person.first_name}}  {{cr.data.person.last_name}} 

         						  	 <span v-if="cr.data.officer_status==1"> appointed as </span>
           				 			 <span v-if="cr.data.officer_status==2"> resigned as </span> 
           				 			 
           				 			  <span v-if="cr.data.position==1 || cr.data.position==2"> director </span>
           				 			  <span v-if="cr.data.position==3"> secretary </span>
           				 			  <span v-if="cr.data.position==4"> director & secretary </span>   	
           				 			  <span v-if="task.header_type!=7 && cr.data.effective_date"> on {{cr.data.effective_date_str}}</span>			 			 
           				 		
          				     </base-alert>	
           				 </span>
           				  <!--  end -->	
           				  
           				  
           				   <!--  start -->
           				    <span v-if="cr.type=='change_shareholder'">
           				 	  <base-alert  type="primary" icon="ni ni-like-2">
           				 	  <i class="ni ni-paper-diploma"></i>     
           				 	  &nbsp; 
								  {{cr.data.num_shares}} 
									<span v-if="cr.data.share_type==1">Ordinary</span>
									  <span v-if="cr.data.share_type==2">Preference</span>
									  <span v-for="st in cr.data.share_types" :key="st.id">
										  <span v-if="cr.data.share_type==st.id">{{st.name}}</span>
									  </span>
							  
								   Shares
								  ({{cr.data.paid_up_capital}} {{cr.data.currency}})
								 <span v-if="cr.data.transaction_type==3">
									 from 	 
									<span v-if="cr.data.company_info2">
								
										{{cr.data.company_info2.company_name}}  ({{cr.data.company_info2.company_reg_num}} )
								
									</span>
								
									<span v-else> {{cr.data.person2.first_name}}  {{cr.data.person2.last_name}} </span>
								 </span>
								 to   
							
									<span v-if="cr.data.company_info">
								
										{{cr.data.company_info.company_name}}  ({{cr.data.company_info.company_reg_num}} )
								
									</span>
								<span v-else>  {{cr.data.person.first_name}}  {{cr.data.person.last_name}}  </span>
								<span v-if="task.header_type!=7 && cr.data.effective_date"> on {{cr.data.effective_date_str}}</span>
								 </base-alert>	
           				 </span>
           			  <!--  end -->	
           				 
           				 
              		</div><!-- end v-for CR-->
              	 
              	  
              	  
              	  
              		
              		
              		
              		
                    <div style="min-height:0px;"></div>
                  
                <div class="mt-3">
            
                	
                	
                	 <span v-if="task.main_document_obj">
                	 	<base-button outline @click="viewDocument(task.main_document, 0)"  size="sm" type="danger">
                	 		<div style="padding:7px 15px;">View {{task.main_document_obj.document_name}}</div>
                	 	
                	 	</base-button> &nbsp;
                	 
                	 
						 <base-button outline v-if="task.main_document_obj.signed_document_file_name" @click="viewDocument(task.main_document, 1)"  size="sm" type="info">
							 <div style="padding:7px 15px;">View Signed Version</div>
						 </base-button>                	 		
                	</span>
                	
                	<div v-for="doc in task.doc_array" style="margin-top:5px;" :key="doc.id">
                	
                		<base-button outline @click="viewDocument(doc.id, 0)"  size="sm" type="danger">
                				<div style="padding:7px 15px;">View {{doc.document_name}}</div>
                		</base-button> &nbsp;
                		
                		 <base-button outline v-if="doc.signed_document_file_name" @click="viewDocument(doc.id, 1)"  size="sm" type="info">
							 <div style="padding:7px 15px;">View Signed Version</div>
						 </base-button>   
                	
                	</div>
                	
                	
                 
                </div>
                
                <div style="min-height:80px;"></div>

              </time-line-item>
				
			






             
            </time-line>
          </card>
        </div>
        <div class="col-lg-6">
          
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import { TimeLine, TimeLineItem } from '@/components';
  import RouteBreadcrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import BaseHeader from '@/components/BaseHeader';
  import Badge from '@/components/Badge';
   
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
   
  export default {
    components: {
      Badge,
      BaseHeader,
      TimeLine,
      TimeLineItem,
      RouteBreadcrumb
    },
     data() {
      return {
     	 tasks:[],
	
      };
    },
    methods: {
      initBigChart(index) {

      },
      viewDocument(did, type){
      			this.$router.push( '/view-document/'+ did +"/"+type);
      },
    },
    mounted() {
       swal.showLoading();
      
		const client_info = JSON.parse(TokenService.getUserInfo());
      	let uri = this.$base_url+'/api/v1/c/get_e_tasks/'+ client_info.entity_id;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.tasks = response.data.tasks;
      		  swal.close();
   
      	})
      	
      	
    }
  };
</script>
<style>

.timeline-one-side .timeline-content{
	max-width:34rem!important;
	
}

</style>








